var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 11,
    viewBox: "0 0 19 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.48026 10.7917C9.3136 10.7917 9.16082 10.7639 9.02193 10.7083C8.88304 10.6528 8.74415 10.5556 8.60526 10.4167L0.355263 2.16667C0.105263 1.91667 -0.0127924 1.61806 0.00109649 1.27083C0.0149854 0.923611 0.14693 0.625 0.39693 0.375C0.64693 0.125 0.945541 0 1.29276 0C1.63999 0 1.9386 0.125 2.1886 0.375L9.48026 7.70833L16.8136 0.375C17.0636 0.125 17.3553 0.00694444 17.6886 0.0208333C18.0219 0.0347222 18.3136 0.166667 18.5636 0.416667C18.8136 0.666667 18.9386 0.965278 18.9386 1.3125C18.9386 1.65972 18.8136 1.95833 18.5636 2.20833L10.3553 10.4167C10.2164 10.5556 10.0775 10.6528 9.9386 10.7083C9.79971 10.7639 9.64693 10.7917 9.48026 10.7917Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.854877f32e8f1db307bdc143dbfed2f4.svg";
export { ForwardRef as ReactComponent };